import { DetailItemCards } from "../../../detail-item-cards";
import { DetailSection } from "../../../detail-section";
import type { GuinchosGuindastesSectionViewModel } from "./types-guinchos-guindastes-section";

export function GuinchosGuindastesSectionView({
  id,
  title,
  testId,
  cardsTestId,
  status,
  errorMessage,
  loadingMessage,
  emptyContent,
  onReauthenticate,
  onRetry,
  ultimaAtualizacao,
  cards,
}: GuinchosGuindastesSectionViewModel) {
  return (
    <DetailSection
      id={id}
      title={title}
      ultimaAtualizacao={ultimaAtualizacao}
      testId={testId}
      status={status}
      loadingMessage={loadingMessage}
      errorMessage={errorMessage}
      emptyContent={emptyContent}
      onReauthenticate={onReauthenticate}
      onRetry={onRetry}
    >
      <DetailItemCards testId={cardsTestId} cards={cards} />
    </DetailSection>
  );
}
